import { render, staticRenderFns } from "./ReceivingDetail.vue?vue&type=template&id=483c110f&scoped=true"
import script from "./ReceivingDetail.vue?vue&type=script&lang=js"
export * from "./ReceivingDetail.vue?vue&type=script&lang=js"
import style0 from "./ReceivingDetail.vue?vue&type=style&index=0&id=483c110f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483c110f",
  null
  
)

export default component.exports